export default __webpack_public_path__ + "static/media/cf1.36ce0fb5.jpg";